<div class="app-transport-options">
  <app-transport-options-panel [model]="model"></app-transport-options-panel>
</div>
